
import React, { useState } from 'react';

const Jobs = () => {
  const jobList = [
    { id: 1, title: "LKW-Fahrer (m/w/d) Fernverkehr", typ: "Vollzeit", ort: "Hamburg / Bundesweit", gehalt: "Ab 3.200€" },
    { id: 2, title: "Disponent Logistik", typ: "Vollzeit", ort: "Berlin", gehalt: "Nach Vereinbarung" },
    { id: 3, title: "Lagerhelfer", typ: "Teilzeit", ort: "München", gehalt: "15€ / Std." },
    { id: 4, title: "Kurierfahrer für Elektro-Transporter", typ: "Minijob", ort: "Leipzig", gehalt: "538€ Basis" }
  ];

  const cardStyle = {
    backgroundColor: '#fff',
    padding: '25px',
    borderRadius: '15px',
    boxShadow: '0 5px 20px rgba(0,0,0,0.04)',
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transition: 'transform 0.2s'
  };

  const badgeStyle = {
    backgroundColor: '#e2e8f0',
    padding: '5px 12px',
    borderRadius: '20px',
    fontSize: '0.85rem',
    color: '#4a5568'
  };

  return (
    <div style={{ padding: '30px 20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ marginBottom: '30px' }}>Aktuelle Stellenangebote</h1>
      
      {jobList.map(job => (
        <div key={job.id} style={cardStyle}>
          <div>
            <h3 style={{ margin: '0 0 10px 0' }}>{job.title}</h3>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <span style={badgeStyle}>{job.typ}</span>
              <span style={{ color: '#718096', fontSize: '0.9rem' }}>📍 {job.ort}</span>
            </div>
            <p style={{ marginTop: '10px', fontWeight: 'bold', color: '#2d3748' }}>{job.gehalt}</p>
          </div>
          <button style={{
            padding: '12px 20px',
            backgroundColor: '#2b6cb0',
            color: 'white',
            border: 'none',
            borderRadius: '10px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}>
            Details
          </button>
        </div>
      ))}
    </div>
  );
};

export default Jobs;